if (!customElements.get('dopplepay-widget')) {
  class DopplePayWidget extends HTMLElement {
    constructor() {
      super();
      this.modalId = this.dataset.modalId;
      this.baseUrl = this.dataset.baseUrl;
      this.initialPriceCents = Number(this.dataset.initialPriceCents || 0);
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.modal = document.getElementById(this.modalId);
      this.iframe = this.modal ? this.modal.querySelector('.dopplepay-iframe') : null;

      // Seed src now
      this.updateIframeSrc(this.initialPriceCents);

      // Bind to variant changes for the product this widget is inside
      const product = this.closest('.product');
      if (product) {
        const variantPicker = product.querySelector('variant-picker');
        if (variantPicker) {
          variantPicker.addEventListener('on:variant:change', (evt) => {
            const variant = evt.detail && evt.detail.variant;
            if (variant && typeof variant.price === 'number') {
              this.updateIframeSrc(variant.price);
            }
          });
        }

        // Listen for unified product price change events (e.g. Easify updates)
        product.addEventListener('on:product-price:change', (evt) => {
          const detail = evt.detail || {};
          const amountMinor =
            typeof detail.amountMinor === 'number'
              ? detail.amountMinor
              : typeof detail.amount === 'number'
                ? detail.amount
                : null;
          if (typeof amountMinor === 'number') {
            this.updateIframeSrc(amountMinor);
          }
        });
      }

      // Also refresh on modal open to ensure latest price
      const opener = this.querySelector('modal-opener');
      if (opener) {
        opener.addEventListener('click', () => {
          const price = this.getCurrentPriceFromDom() || this.initialPriceCents;
          this.updateIframeSrc(price);
        });
      }
    }

    getCurrentPriceFromDom() {
      // Prefer reading from the nearest price component inside this product
      const product = this.closest('.product');
      if (!product) return null;

      // Try Easify-rendered current price first
      let priceEl = product.querySelector(
        '.product-info__price .price .price__current.tpo_product_price'
      );

      // Fallback to hidden .js-value inside price if present
      if (!priceEl) {
        priceEl = product.querySelector('.product-info__price .price .price__current .js-value');
      }

      // Fallback to any visible .price__current element
      if (!priceEl) {
        priceEl = product.querySelector('.product-info__price .price .price__current');
      }
      if (!priceEl) return null;
      try {
        // Strip currency and formatting, convert to pounds, then to integer pounds for API
        const text = priceEl.textContent || '';
        const numeric = text.replace(/[^0-9.,]/g, '').replace(/,/g, '');
        const pounds = parseFloat(numeric);
        if (Number.isFinite(pounds)) {
          return Math.round(pounds * 100); // convert to cents/pennies
        }
      } catch {}
      return null;
    }

    updateIframeSrc(priceCents) {
      if (!this.iframe || !this.baseUrl) return;
      const pounds = Math.max(0, Math.round(priceCents / 100));
      this.iframe.src = `${this.baseUrl}${encodeURIComponent(pounds)}`;
    }
  }

  customElements.define('dopplepay-widget', DopplePayWidget);
}
